import React from 'react'
import { DraggableDeliverable, LayerBox } from './LayerBox'
import PdfDeliverableContainer from '../../containers/DeliverablesContainers/PdfDeliverableContainer'
import DeliverablesSourceSelector from './DeliverablesSourceSelector'
import isEmpty from 'lodash/isEmpty'
import size from 'lodash/size'
import noop from 'lodash/noop'
import styled from 'styled-components'
import { trackLayerVisibilityToggled, trackLayerOpacityChanged, trackLayerReordered, LAYER_TABS } from './layersTracking'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`

const LayerBoxesWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`

function DeliverablesLayerBoxesContainer({
  changeOpacity,
  deliverables,
  isLayers,
  isTemporalView,
  pdfDeliverables,
  setLayerOrder,
  setTemporalComparison,
  toggleDeliverable,
  toggleVisibility,
  setVisibilitySeasonLayer,
  setOpacitySeasonLayer,
  setOrderSeasonLayers,
  toggleSeasonLayerLegends,
  seasonLayers,
  activeTab,
  activeDateCalendarDots,
  selectFlightGroup,
  selectedFlightGroupIndex,
  cloudCoverage
}) {
  const isLayersTab = isLayers && activeTab === 'layers'
  const isDownloadsTab = !isLayersTab && activeTab === 'downloads'
  const isSeasonLayersTab = activeTab === 'seasonLayers'

  const layerBoxes = [
    <LayerBox
      layers={deliverables}
      key="DraggableDeliverable"
      isDraggable={true}
      onSortEnd={(oldIndex, newIndex) => {
        const moved = deliverables[oldIndex]
        if (moved) {
          trackLayerReordered({ id: moved.id, name: moved.type.name, from: oldIndex, to: newIndex, tab: LAYER_TABS.LAYERS })
        }
        setLayerOrder(oldIndex, newIndex)
      }}
      visible={isLayersTab}
      renderLayer={(deliverable, index) => (
        <DraggableDeliverable
          idx={index}
          index={index}
          key={index}
          deliverable={deliverable}
          isTemporal={isTemporalView}
          toggleVisibility={() => {
            trackLayerVisibilityToggled({ layer: deliverable.type.name, typeId: deliverable.type.id, visible: !deliverable.visible, tab: LAYER_TABS.LAYERS })
            toggleVisibility(deliverable)
          }}
          clickTemporal={() => setTemporalComparison(deliverable)}
          toggleDeliverable={() => toggleDeliverable(deliverable)}
          changeOpacity={opacity => changeOpacity(deliverable, opacity)}
          onOpacityCommit={opacity =>
            trackLayerOpacityChanged({
              layer: deliverable.type.name,
              typeId: deliverable.type.id,
              opacity,
              tab: LAYER_TABS.LAYERS
            })
          }
        />
      )}
    />
  ]

  if (!isEmpty(seasonLayers)) {
    layerBoxes.push(
      <LayerBox
        layers={seasonLayers}
        key="SEASON_LAYERS"
        isDraggable={true}
        onSortEnd={(oldIndex, newIndex) => {
          const moved = seasonLayers[oldIndex]
          if (moved) {
            trackLayerReordered({ id: moved.id, name: moved.type.name, from: oldIndex, to: newIndex, tab: LAYER_TABS.SEASON_LAYERS })
          }
          setOrderSeasonLayers(oldIndex, newIndex)
        }}
        visible={isSeasonLayersTab}
        renderLayer={(deliverable, index) => (
          <DraggableDeliverable
            idx={index}
            index={index}
            key={index}
            deliverable={deliverable}
            isTemporal={isTemporalView}
            toggleVisibility={() => {
              trackLayerVisibilityToggled({
                layer: deliverable.type.name,
                typeId: deliverable.type.id,
                visible: !deliverable.visible,
                tab: LAYER_TABS.SEASON_LAYERS
              })
              setVisibilitySeasonLayer(index, !deliverable.visible)
            }}
            clickTemporal={noop}
            toggleDeliverable={() => toggleSeasonLayerLegends(index)}
            changeOpacity={opacity => setOpacitySeasonLayer(index, opacity)}
            onOpacityCommit={opacity =>
              trackLayerOpacityChanged({
                layer: deliverable.type.name,
                typeId: deliverable.type.id,
                opacity,
                tab: LAYER_TABS.SEASON_LAYERS
              })
            }
          />
        )}
      />
    )
  }

  if (!isEmpty(pdfDeliverables)) {
    layerBoxes.push(
      <LayerBox
        key="pdfwrapper"
        layers={pdfDeliverables}
        className={'pdfwrapper'}
        renderLayer={(deliverable, index) => <PdfDeliverableContainer index={index} deliverable={deliverable} />}
        visible={isDownloadsTab}
      />
    )
  }

  return (
    <Wrapper>
      {size(activeDateCalendarDots) > 1 && isLayersTab && (
        <DeliverablesSourceSelector
          activeDateCalendarDots={activeDateCalendarDots}
          selectFlightGroup={selectFlightGroup}
          selectedFlightGroupIndex={selectedFlightGroupIndex}
          cloudCoverage={cloudCoverage}
        />
      )}
      <LayerBoxesWrapper>{layerBoxes}</LayerBoxesWrapper>
    </Wrapper>
  )
}

export default DeliverablesLayerBoxesContainer
